import React from "react";
import Header from "../components/Header";

const TvShow = () => {
  return (
    <div>
      <Header />
      <div className="page_content">
        <h1>Tv Shows</h1>
      </div>
    </div>
  );
};

export default TvShow;
